/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

const addNewRelicScript = () => {
  const script = document.createElement('script');
  script.src = '/scripts/' + environment.newRelicScriptFileName;
  document.head.appendChild(script);
};

if (environment.newRelicEnabled) {
  addNewRelicScript();
}

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
